import React, { useState } from 'react';
import { Download, File, X } from 'lucide-react';
import { formatFileSize, getFileExtension } from '../utils/fileHelpers';

const MessageAttachment = ({ attachment, onRemove, isPreview = false }) => {
  const [imageError, setImageError] = useState(false);
  
  const renderAttachment = () => {
    // Image attachments
    if (attachment.file_type === 'image') {
      if (imageError) {
        return renderDocumentCard();
      }
      
      return (
        <div style={{
          position: 'relative',
          borderRadius: '8px',
          overflow: 'hidden',
          maxWidth: '300px',
          cursor: 'pointer'
        }}
        onClick={() => !isPreview && window.open(attachment.file_url, '_blank')}
        >
          <img
            src={attachment.file_url}
            alt={attachment.file_name}
            onError={() => setImageError(true)}
            style={{
              width: '100%',
              height: 'auto',
              display: 'block'
            }}
          />
          {onRemove && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onRemove();
              }}
              style={{
                position: 'absolute',
                top: '8px',
                right: '8px',
                background: 'rgba(0, 0, 0, 0.6)',
                border: 'none',
                borderRadius: '50%',
                width: '24px',
                height: '24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                color: '#FFFFFF'
              }}
            >
              <X size={16} />
            </button>
          )}
        </div>
      );
    }
    
    // Video attachments
    if (attachment.file_type === 'video') {
      return (
        <div style={{
          position: 'relative',
          borderRadius: '8px',
          overflow: 'hidden',
          maxWidth: '400px'
        }}>
          <video
            controls
            style={{
              width: '100%',
              height: 'auto',
              display: 'block'
            }}
          >
            <source src={attachment.file_url} type={attachment.mime_type} />
            Your browser does not support the video tag.
          </video>
          {onRemove && (
            <button
              onClick={onRemove}
              style={{
                position: 'absolute',
                top: '8px',
                right: '8px',
                background: 'rgba(0, 0, 0, 0.6)',
                border: 'none',
                borderRadius: '50%',
                width: '24px',
                height: '24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                color: '#FFFFFF'
              }}
            >
              <X size={16} />
            </button>
          )}
        </div>
      );
    }
    
    // Document attachments (PDF, DOCX)
    return renderDocumentCard();
  };
  
  const renderDocumentCard = () => {
    const extension = getFileExtension(attachment.file_name);
    
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '12px',
        background: '#F3F4F6',
        borderRadius: '8px',
        border: '1px solid #E5E7EB',
        maxWidth: '300px',
        position: 'relative'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          borderRadius: '6px',
          background: '#3B82F6',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#FFFFFF',
          fontSize: '12px',
          fontWeight: '600',
          flexShrink: 0
        }}>
          {extension}
        </div>
        
        <div style={{ flex: 1, minWidth: 0 }}>
          <p style={{
            fontSize: '14px',
            fontWeight: '500',
            color: '#0A0A0A',
            margin: '0 0 4px 0',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}>
            {attachment.file_name}
          </p>
          <p style={{
            fontSize: '12px',
            color: '#6B7280',
            margin: 0
          }}>
            {formatFileSize(attachment.size_bytes)}
          </p>
        </div>
        
        {!isPreview && (
          <a
            href={attachment.file_url}
            download={attachment.file_name}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              padding: '8px',
              background: '#FFFFFF',
              border: '1px solid #E5E7EB',
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#3B82F6',
              cursor: 'pointer',
              textDecoration: 'none'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Download size={16} />
          </a>
        )}
        
        {onRemove && (
          <button
            onClick={onRemove}
            style={{
              position: 'absolute',
              top: '-8px',
              right: '-8px',
              background: '#DC2626',
              border: 'none',
              borderRadius: '50%',
              width: '20px',
              height: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              color: '#FFFFFF'
            }}
          >
            <X size={12} />
          </button>
        )}
      </div>
    );
  };
  
  return renderAttachment();
};

export default MessageAttachment;
